<template>
  <div class="is-flex">
    <LinkEntity :payload="payload.resources.applicant" />
    <LinkEntity :payload="payload.resources.position" :additional_data="{ resource_type: 'Position' }" />
    <LinkEntity :payload="payload.resources.company" />
  </div>
</template>
<script>
import LinkEntity from '@/components/LinkEntity'

export default {
  name: 'AlertVettedOffer',
  components: {
    LinkEntity
  },
  props: {
    payload: {
      type: Object
    }
  }
}
</script>
